export default {
  "Supprimer « {0} » ?": "Delete “{0}”?",
  "Automatisation supprimée.": "Automation deleted.",
  "Activé": "Enabled",
  "« {0} » activé.": "“{0}” enabled.",
  "Aucune exécution": "No runs",
  "Chaque exécution apparaîtra ici avec son résultat, ses éventuelles erreurs et les actions à valider.": "Each run will appear here with its result, any errors and the actions to approve.",
  "Voir tout le journal": "See the full log",
  "Tâches": "Tasks",
  "Bilans": "Reviews",
  "Rappels, échéances, alertes financières et activité. Préférences dans Paramètres › Notifications.": "Reminders, due dates, financial alerts and activity. Preferences in Settings › Notifications.",
  "Tout marquer comme lu": "Mark all as read",
  "Filtre": "Filter",
  "Toutes": "All",
  "Non lues": "Unread",
  "Archivées": "Archived",
  "Aucune notification": "No notifications",
  "Les rappels de tâches, d'agenda et de factures apparaîtront ici.": "Task, calendar and invoice reminders will appear here.",
  "Activité": "Activity",
  "Marquer comme non lue": "Mark as unread",
  "Marquer comme lue": "Mark as read",
  "Désarchiver": "Unarchive",
  "En retard": "Overdue",
  "À venir": "Upcoming",
  "Terminées": "Done",
  "Ajouter une tâche…  (ex. « Appeler Martin demain !4 »)": "Add a task…  (e.g. “Call Martin tomorrow !4”)",
  "Ajouter une tâche rapidement": "Quickly add a task",
  "en retard": "overdue",
  "Sans échéance": "No due date",
  " · {0} de travail estimé restant": " · {0} of estimated work left",
  " · échéance {0}": " · due {0}",
  "{0} ouvertes · {1} terminées cette semaine{2}": "{0} open · {1} done this week{2}",
  "Risques identifiés": "Identified risks",
  "Toutes les tâches": "All tasks",
  "Supprimer « {0} ». Supprimer aussi ses {1} tâche(s) ? (Annuler = conserver les tâches)": "Delete “{0}”. Also delete its {1} task(s)? (Cancel = keep the tasks)",
  "Aucun projet. Créez-en un ou lancez une mission.": "No projects. Create one or launch a mission.",
  "Vue": "View",
  "Tableau par statut": "Board by status",
  "Rechercher une tâche": "Search a task",
  "Disposition": "Layout",
  "Liste": "List",
  "Tableau": "Board",
  "Rien d'urgent aujourd'hui": "Nothing urgent today",
  "Aucun retard": "Nothing overdue",
  "Aucune tâche": "No tasks",
  "Ajoutez une tâche ou demandez au coach de préparer votre journée.": "Add a task or ask the coach to plan your day.",
  "Utilisez la saisie rapide ci-dessus.": "Use the quick entry above.",
  "Déposez une tâche ici": "Drop a task here",
  "Glissez-déposez une carte pour changer son statut (ou ouvrez-la sur mobile).": "Drag and drop a card to change its status (or open it on mobile).",
  "Aide-moi à prioriser ma semaine : voici ce que j'ai à faire…": "Help me prioritise my week: here's what I have to do…",
  "Prépare un plan pour trouver 3 nouveaux clients ce mois-ci.": "Prepare a plan to find 3 new customers this month.",
  "Rédige un e-mail de relance courtois pour une facture impayée.": "Write a polite follow-up email for an unpaid invoice.",
  "Comment fixer le prix de ma nouvelle offre ?": "How should I price my new offer?",
  "{0} tâche(s)": "{0} task(s)",
  "{0} événement(s)": "{0} event(s)",
  "vos finances du mois": "your finances this month",
  "{0} facture(s) à encaisser": "{0} invoice(s) to collect",
  "{0} document(s) de votre base de connaissances": "{0} document(s) from your knowledge base",
  "Nouvelle conversation": "New conversation",
  "Rechercher dans les conversations": "Search conversations",
  "Récentes": "Recent",
  "Aucune conversation ne correspond.": "No matching conversations.",
  "Aucune conversation archivée.": "No archived conversations.",
  "Aucune conversation pour l'instant.": "No conversations yet.",
  "Renommer la conversation": "Rename conversation",
  "Supprimer cette conversation ?": "Delete this conversation?",
  "Elle sera définitivement effacée, avec tous ses messages.": "It will be permanently erased, with all its messages.",
  "Information fausse ou trompeuse": "False or misleading information",
  "Conseil dangereux": "Dangerous advice",
  "Contenu choquant ou offensant": "Shocking or offensive content",
  "Contenu inapproprié": "Inappropriate content",
  "Autre": "Other",
  "Signaler cette réponse": "Report this answer",
  "Votre signalement est examiné par notre équipe pour améliorer le Coach.": "Your report is reviewed by our team to improve the Coach.",
  "Merci, votre signalement a été envoyé.": "Thank you, your report has been sent.",
  "Précisions (facultatif)": "Details (optional)",
  "Précisions": "Details",
  "Envoyer le signalement": "Send report",
  "La réponse n'a pas pu être générée.": "The answer could not be generated.",
  "Génération interrompue.": "Generation stopped.",
  "Données de l'application transmises au coach pour cette réponse (lecture seule)": "App data shared with the coach for this answer (read-only)",
  "Basé sur :": "Based on:",
  "Copier la réponse": "Copy answer",
  "Arrêter la lecture": "Stop reading",
  "Écouter la réponse": "Listen to the answer",
  "Régénérer la réponse": "Regenerate answer",
  "Signaler": "Report",
  "Écrivez à votre coach…": "Write to your coach…",
  "Message au coach": "Message to the coach",
  "Arrêter la génération": "Stop generating",
  "IA indisponible.": "AI unavailable.",
  "La connexion a été interrompue.": "The connection was interrupted.",
  "Retour aux conversations": "Back to conversations",
  "Mode du coach": "Coach mode",
  "Parlez à votre Copilote comme à un assistant : il vous écoute et vous répond à voix haute, mains libres.": "Talk to your Copilot like an assistant: it listens and answers out loud, hands-free.",
  "Mode vocal mains libres": "Hands-free voice mode",
  "Vocal": "Voice",
  "Conversation introuvable": "Conversation not found",
  "Chargement impossible": "Unable to load",
  "Comment puis-je vous aider,": "How can I help you,",
  "Coach IA non configuré": "AI Coach not configured",
  "Préparation des actions proposées…": "Preparing proposed actions…",
  "Le coach réfléchit…": "The coach is thinking…",
  "Quota IA quotidien atteint (": "Daily AI quota reached (",
  "messages). Il sera réinitialisé à minuit UTC.": "messages). It resets at midnight UTC.",
  "Le coach peut se tromper : vérifiez les informations importantes.": "The coach can make mistakes: check important information.",
  "aujourd'hui": "today",
  "Bonne nuit": "Good night",
  "Bonjour": "Good morning",
  "Bon après-midi": "Good afternoon",
  "Bonsoir": "Good evening",
  "Pourquoi :": "Why:",
  "Calculé à partir de vos tâches, de votre agenda et de vos horaires — aucune donnée inventée.": "Calculated from your tasks, calendar and working hours — no made-up data.",
  "Régénérer la synthèse": "Regenerate summary",
  "Synthèse du coach": "Coach summary",
  "Maintenant :": "Now:",
  "Synthèse générée par": "Summary generated by",
  "à partir des faits ci-dessous.": "from the facts below.",
  "Les 3 priorités recommandées": "The 3 recommended priorities",
  "Aucune tâche ouverte. Ajoutez vos tâches ou lancez une mission.": "No open tasks. Add your tasks or launch a mission.",
  "Radar : risques et opportunités": "Radar: risks and opportunities",
  "Agenda du jour": "Today's calendar",
  "Aucun rendez-vous aujourd'hui.": "No appointments today.",
  "Créneaux libres": "Free slots",
  "Jour non travaillé selon vos préférences.": "Non-working day in your preferences.",
  "Plus de créneau libre aujourd'hui.": "No more free slots today.",
  "échéance(s) aujourd'hui": "due today",
  "{0} estimées": "{0} estimated",
  "Terminées (7 j)": "Done (7 d)",
  "Échéances tenues": "Deadlines met",
  "7 derniers jours": "Last 7 days",
  "À faire aujourd'hui": "To do today",
  "Rien d'urgent aujourd'hui.": "Nothing urgent today.",
  "Tâches terminées — 14 derniers jours": "Tasks done — last 14 days",
  "Nombre de tâches terminées par jour sur les 14 derniers jours": "Number of tasks done per day over the last 14 days",
  "Conversations récentes": "Recent conversations",
  "Tout voir": "See all",
  "Aucune conversation.": "No conversations.",
  "Objectifs déclarés": "Stated goals",
  "Aucun objectif renseigné.": "No goals entered.",
  "IA :": "AI:",
  "messages aujourd'hui · formule": "messages today · plan",
  "Créé": "Created",
  "· généré par l'IA, à relire": "· AI-generated, to review",
  "Ouvrir l'e-mail": "Open email",
  "E-mail de suivi": "Follow-up email",
  "Brouillon créé dans Documents. Rien n'a été envoyé.": "Draft created in Documents. Nothing was sent.",
  "Collez vos notes ou dictez le déroulé : compte rendu structuré, décisions, actions à valider et e-mail de suivi en un clic.": "Paste your notes or dictate what happened: structured minutes, decisions, actions to approve and a follow-up email in one click.",
  "Titre (facultatif)": "Title (optional)",
  "Ex. Point mensuel Martin & Co": "E.g. Monthly catch-up Martin & Co",
  "Notes de réunion": "Meeting notes",
  "Qui était là, ce qui a été dit, décidé, ce qu'il reste à faire… même en vrac.": "Who was there, what was said, decided, what's left to do… even unstructured.",
  "Analyser la réunion": "Analyse the meeting",
  "Les actions détectées sont proposées : aucune tâche n'est créée sans votre validation.": "Detected actions are proposed: no task is created without your approval.",
  "Réunions récentes": "Recent meetings",
  "Aucun compte rendu": "No minutes",
  "En attendant, sans rien connecter : dans un document e-mail, « Ouvrir dans Gmail » ; dans un rendez-vous, « Google Agenda » ou « Créer une visio Meet ».": "Meanwhile, without connecting anything: in an email document, “Open in Gmail”; in an appointment, “Google Calendar” or “Create a Meet call”.",
  "En attendant, copiez le texte depuis le Coach et collez-le dans Slack.": "Meanwhile, copy the text from the Coach and paste it into Slack.",
  "En attendant, dans Notion : ••• → Exporter → Markdown, puis déposez le fichier dans Fichiers.": "Meanwhile, in Notion: ••• → Export → Markdown, then drop the file into Files.",
  "Connecté": "Connected",
  "À reconnecter": "Reconnect needed",
  "Activation requise": "Activation required",
  "Se connecter avec": "Connect with",
  "(guide pas à pas)": "(step-by-step guide)",
  "Bientôt disponible : l'administrateur doit d'abord l'activer.": "Coming soon: the administrator must enable it first.",
  "Agenda Google : {0} ajouté(s), {1} mis à jour.": "Google Calendar: {0} added, {1} updated.",
  "Importer mon agenda Google (30 jours)": "Import my Google Calendar (30 days)",
  "Message de test envoyé.": "Test message sent.",
  "Message test": "Test message",
  "Briefing envoyé sur Slack.": "Briefing sent to Slack.",
  "Envoyer le briefing": "Send the briefing",
  "Rechercher une page Notion": "Search a Notion page",
  "Aucune page partagée avec GBC Coach IA ne correspond.": "No page shared with GBC Coach IA matches.",
  "« {0} » importée dans Fichiers et connaissances.": "“{0}” imported into Files and knowledge.",
  "Déconnecter {0} ?": "Disconnect {0}?",
  "{0} déconnecté.": "{0} disconnected.",
  "Déconnecter": "Disconnect",
  "Dernière utilisation": "Last used",
  "Réglages administrateur": "Admin settings",
  "Disponible": "Available",
  "Non configuré": "Not configured",
  "Prévu": "Planned",
  "Désactiver le lien ? Les agendas abonnés ne recevront plus de mises à jour.": "Disable the link? Subscribed calendars will no longer receive updates.",
  "Abonnement d'agenda (iCal)": "Calendar subscription (iCal)",
  "Vos événements et échéances de tâches de cet espace apparaissent dans Google Agenda, Apple Calendrier ou Outlook (lecture seule, mise à jour automatique par votre agenda).": "Your events and task due dates from this workspace appear in Google Calendar, Apple Calendar or Outlook (read-only, updated automatically by your calendar).",
  "Lien privé — copiez-le maintenant, il ne sera plus affiché :": "Private link — copy it now, it won't be shown again:",
  "Google Agenda : Autres agendas → « À partir de l'URL ». Apple : Fichier → Nouvel abonnement. Outlook : Ajouter un calendrier → « S'abonner à partir du web ».": "Google Calendar: Other calendars → “From URL”. Apple: File → New Calendar Subscription. Outlook: Add calendar → “Subscribe from web”.",
  "Lien actif depuis": "Link active since",
  ". Pour le retrouver, générez-en un nouveau (l'ancien sera désactivé).": ". To get it again, generate a new one (the old one will be disabled).",
  "Régénérer le lien": "Regenerate link",
  "Créer le lien": "Create link",
  "{0} événement(s) importé(s).": "{0} event(s) imported.",
  "Importer un agenda (.ics)": "Import a calendar (.ics)",
  "Exportez votre agenda depuis Google, Outlook ou Apple puis importez le fichier : aperçu avant import, doublons ignorés.": "Export your calendar from Google, Outlook or Apple, then import the file: preview before import, duplicates skipped.",
  "{0} événement(s) déjà importé(s).": "{0} event(s) already imported.",
  "Fichier .ics": ".ics file",
  "Fichier trop volumineux (2 Mo maximum).": "File too large (2 MB maximum).",
  "Choisir un fichier .ics": "Choose an .ics file",
  "à importer": "to import",
  "déjà présent(s) ·": "already present ·",
  "trop ancien(s)": "too old",
  " · {0} ignoré(s)": " · {0} skipped",
  " (récurrent)": " (recurring)",
  "événement(s)": "event(s)",
  "{0} est connecté.": "{0} is connected.",
  "Connectez GBC Coach IA à vos outils en un clic, avec votre propre compte. Aucun mot de passe n'est demandé ici.": "Connect GBC Coach IA to your tools in one click, with your own account. No password is requested here.",
  "Connexion en un clic": "One-click connection",
  "Charge des 7 prochains jours": "Workload for the next 7 days",
  "de travail estimé pour": "of estimated work for",
  "de créneaux libres.": "of free slots.",
  "Surcharge détectée : reportez, déléguez ou réduisez certaines tâches.": "Overload detected: postpone, delegate or reduce some tasks.",
  "Estimation : 30 min par tâche sans durée renseignée.": "Estimate: 30 min per task without a duration.",
  "Agenda, créneaux de concentration et planification intelligente de vos tâches.": "Calendar, focus slots and smart scheduling of your tasks.",
  "Précédent": "Previous",
  "Suivant": "Next",
  "Vue du calendrier": "Calendar view",
  "Semaine": "Week",
  "Mois": "Month",
  "Les tâches planifiées apparaissent en pointillés ; les échéances en haut de chaque journée. Importez votre agenda Google depuis Intégrations, ou envoyez un rendez-vous vers Google Agenda ou Outlook en un clic.": "Scheduled tasks appear dotted; due dates at the top of each day. Import your Google Calendar from Integrations, or send an appointment to Google Calendar or Outlook in one click.",
  "Dans les temps": "On track",
  "À surveiller": "At risk",
  "Atteint": "Achieved",
  "Abandonné": "Abandoned",
  "Rythme attendu : {0} %": "Expected pace: {0}%",
  "Nouvel objectif": "New goal",
  "Ex. Signer 10 nouveaux clients": "E.g. Sign 10 new customers",
  "Mesure": "Measure",
  "Nombre": "Number",
  "Pourcentage": "Percentage",
  "Tâches liées terminées": "Linked tasks done",
  "Jalons atteints": "Milestones reached",
  "Date cible": "Target date",
  "Valeur de départ": "Starting value",
  "Cible": "Target",
  "Unité (facultatif)": "Unit (optional)",
  "clients, €, abonnés…": "customers, €, followers…",
  "Jalons (un par ligne, facultatif)": "Milestones (one per line, optional)",
  "Point d'étape": "Check-in",
  "Valeur actuelle ({0})": "Current value ({0})",
  "Nouvelle valeur": "New value",
  "Note de bilan (facultatif)": "Review note (optional)",
  "Note de bilan": "Review note",
  "Jalons": "Milestones",
  "Ajouter un jalon": "Add a milestone",
  "Nouveau jalon": "New milestone",
  "Tâches liées": "Linked tasks",
  "Lier une tâche": "Link a task",
  "Lier une tâche…": "Link a task…",
  "Moteur de progression": "Progress engine",
  "Analyser cet objectif": "Analyse this goal",
  "Prochaines étapes": "Next steps",
  "Blocages possibles": "Possible blockers",
  "Tâches prioritaires": "Priority tasks",
  "Ressources utiles": "Useful resources",
  "Échéance :": "Due:",
  "Bilan hebdomadaire :": "Weekly review:",
  "Supprimer cet objectif ?": "Delete this goal?",
  "Synthèse de la semaine à partir de vos tâches terminées, de vos finances, de vos objectifs et de votre agenda.": "Summary of the week from your completed tasks, finances, goals and calendar.",
  "Générer le bilan de la semaine": "Generate this week's review",
  "Des objectifs mesurables, des jalons et un score de progression transparent — comparé au rythme attendu, jamais à votre valeur personnelle.": "Measurable goals, milestones and a transparent progress score — compared with the expected pace, never with your personal worth.",
  "Aucun objectif": "No goals",
  "Fixez un objectif mesurable : chiffre d'affaires, clients signés, lancement d'offre…": "Set a measurable goal: revenue, customers signed, offer launch…",
  "Créer un objectif": "Create a goal",
  " · attendu {0} %": " · expected {0}%",
  "Brouillon généré : relisez et complétez-le avant tout envoi.": "Draft generated: review and complete it before sending.",
  "Choisissez un modèle.": "Choose a template.",
  "Client (facultatif)": "Customer (optional)",
  "Projet (facultatif)": "Project (optional)",
  "Le générateur peut utiliser votre profil d'entreprise, le client et le projet choisis. Vous vérifiez ensuite les quantités, prix, conditions et mentions.": "The generator can use your business profile and the chosen customer and project. You then check the quantities, prices, terms and legal notices.",
  "Document vierge": "Blank document",
  "Générer avec l'IA": "Generate with AI",
  "Devis, factures, propositions, contrats, comptes rendus… générés avec l'IA, vérifiés, versionnés et exportés.": "Quotes, invoices, proposals, contracts, minutes… generated with AI, checked, versioned and exported.",
  "Rechercher dans les titres et le contenu": "Search titles and content",
  "Rechercher un document": "Search a document",
  "Tous les types": "All types",
  "Archivés": "Archived",
  "facture(s) en retard de paiement :": "invoice(s) overdue:",
  ". Ouvrez-la pour préparer une relance.": ". Open it to prepare a follow-up.",
  "Aucun document": "No documents",
  "Créez votre premier devis ou laissez le coach rédiger une proposition commerciale.": "Create your first quote or let the coach write a sales proposal.",
  "Créer un document": "Create a document",
  "Généré avec l'IA": "AI-generated",
} as Record<string, string>;
